import { parrotClient } from '@libs/parrot-sdk';
import { type CoinBalance } from '@mysten/sui/client';
import { defineModel } from 'foca';

interface BalanceStateStruct {
  balances: Record<string, CoinBalance[]>;
}

const initialState: BalanceStateStruct = {
  balances: {},
};

export const balanceParrotModel = defineModel('balance-parrot', {
  initialState,
  methods: {
    async getBalances(accountAddress: string) {
      const balances = await parrotClient.getAllBalances({
        owner: accountAddress,
      });
      this.setState((state) => {
        state.balances[accountAddress] = balances;
      });
    },
  },
});
